<template>
  <div class="exhibitions_list_page">
    <!-- 展览列表 -->
    <div class="swiper">
      <el-carousel height="400px">
        <el-carousel-item v-for="item in banner" :key="item.id">
          <a v-if="item.link" target="_blank" :href="item.link">
            <img :src="item.coverPath" alt />
          </a>
          <img :src="item.coverPath" alt v-else />
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="filter_box">
      <div class="m">
        <div class="filter_box_l">
          <ul>
            <li :class="{active:searchObj.sort==='SortDefault'}" @click="cutType('SortDefault')">
              精选推荐
            </li>
            <li :class="{active:searchObj.sort==='SortTimeDESC'}" @click="cutType('SortTimeDESC')">
              最新发布
            </li>
            <li :class="{active:searchObj.sort==='SortPopularityDESC'}" @click="cutType('SortPopularityDESC')">
              最热
            </li>
          </ul>
        </div>
        <div class="filter_box_r">
          <el-select
              class="select_class"
              v-model="searchObj.school"
              placeholder="请选择"
              filterable
              style="width:240px;"
              @change="search">
            <el-option
                key="-1"
                label="全部院校"
                value=""
            ></el-option>
            <el-option
              v-for="item in school"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
          <el-input
              class="input_class"
              placeholder="请输入内容"
              v-model="searchObj.name"
              style="width:240px;"
              @keyup.native.enter="search">
            <i slot="suffix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </div>
      </div>
    </div>
    <template v-if="layerpageinfo.total > 0">
      <div class="exhibitions_list_box">
        <div class="m">
          <exhibitions_list :list="list"/>
        </div>
      </div>
      <!-- 分页 -->
      <div class="page_box">
        <myPage :layerpageinfo="layerpageinfo" @pageChange="changePage"></myPage>
      </div>
    </template>
    <div class="m" v-else>
      <!-- 为空 -->
      <div class="no_list" ></div>
    </div>
  </div>
</template>

<script>
import exhibitions_list from "@/components/list_item/exhibitions_list/exhibitions_list";
import myPage from "@/components/myPage/myPage";
export default {
  components: {
    exhibitions_list,
    myPage
  },
  data() {
    return {
      layerpageinfo: {
        pageSize: 6,
        pageNo: 0,
        total: 0
      },
      searchObj:{
        name: '',
        school: '',
        sort: 'SortDefault',
        status:'IdentityCertifieStatussuccess'
      },
      value: "",
      banner: [], //轮播图列表
      list: [], //毕业展列表
      school: [], //学校列表
    };
  },
  created() {
    // 轮播图
    this.getBanner();
    this.getFrontExhibitions();
    this.getSchool();
  },
  methods: {
    //切换类型
    cutType(type){
      this.searchObj.sort = type;
      this.search();
    },
    //点击搜索
    search(){
      this.layerpageinfo.pageNo = 0;
      this.getFrontExhibitions();
    },
    // 页数切换
    changePage(pageNo) {
      this.layerpageinfo.pageNo = pageNo;
      this.getFrontExhibitions();
    },
    // 获取轮播图
    getBanner() {
      let params = {
        type: "ExhibitionCarousel",
        class_one: "ExhibitionCarouselGraduationShow",
        pageNo: 0,
        pageSize: 10,
        sort: "SortDefault"
      };
      this.api.getNews(params).then(res => {
        if (res.error.err_code !== 0) return;
        this.banner = res.obj.list;
      });
    },
    // 获取毕业展列表
    getFrontExhibitions() {
      this.api
        .getFrontExhibitions({
          ...this.layerpageinfo,
          ...this.searchObj
        })
        .then(res => {
          console.log(res);
          if (res.error.err_code !== 0) return;
          let list = res.obj.list;
          this.list = list.length ? list : [];
          this.layerpageinfo.total = res.obj.totalSize;
        });
    },
    //查询学校列表
    getSchool(){
      let params = {}
      this.api.getSchoolsList(params).then(res=>{
        if (res.error.err_code !== 0) return;
        this.school = res.obj.list;
      })
    }
  }
};
</script>

<style lang="scss" >
.exhibitions_list_page {
  background-color: #f5f5f5;
  // 轮播图
  .swiper {
    background: #dbdfe2;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
    }
    .el-carousel__arrow {
      border-radius: 0;
      width: 40px;
      height: 40px;
      i:before {
        content: "";
        background: url(https://sctcc-applet.oss-cn-shenzhen.aliyuncs.com/icons/img/icon1.png)
          no-repeat;
        display: inline-block;
        width: 40px;
        height: 40px;
      }
      i.el-icon-arrow-left::before {
        background-position: -5px -286px;
      }
      i.el-icon-arrow-right::before {
        background-position: -5px -331px;
      }
    }
    .el-carousel__arrow--left {
      left: 60px;
    }
    .el-carousel__arrow--right {
      right: 60px;
    }
    .el-carousel__arrow:hover {
      opacity: 0.4;
    }
  }
  .filter_box {
    background: #fff;
    .m {
      display: flex;
      justify-content: space-between;
      .filter_box_l {
        ul {
          display: flex;
          li {
            height: 80px;
            line-height: 80px;
            font-size: 16px;
            color: #999;
            position: relative;
            cursor: pointer;
            a{
              display: block;
              width: 100%;height: 100%;
              color: #999;
            }
          }
          li + li {
            margin-left: 70px;
          }
          li.active {
            color: #333;
          }
          li.active::after {
            content: "";
            width: 29px;
            height: 3px;
            background: rgba(17, 17, 17, 1);
            position: absolute;
            left: 0;
            right: 0;
            margin: 0 auto;
            bottom: 0;
          }
        }
      }
      .filter_box_r {
        display: flex;
        align-items: center;
        .el-input__inner {
          height: 36px;
          line-height: 36px;
        }
        .input_class {
          margin-left: 20px;
        }
        .el-input-group__append {
          background: none;
        }
      }
    }
  }
  .exhibitions_list_box {
    background: #f5f5f5;
    padding:20px 0 ;
    .m {

    }
  }
}
</style>
